window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".collapsible-title").forEach((trigger) => {
    trigger.addEventListener("click", function () {
      const content = this.parentElement.querySelector(".collapsible-content");
      content.classList.toggle("expanded");

      const openIcon = this.querySelector(".collapsible-icon.open");
      const closedIcon = this.querySelector(".collapsible-icon.closed");
      if (content.classList.contains("expanded")) {
        openIcon.style.display = "inline";
        closedIcon.style.display = "none";
      } else {
        openIcon.style.display = "none";
        closedIcon.style.display = "inline";
      }
    });
  });
});
